// Main function to detect changes within the .product-form-class parent
function handleColorChangeShopTheLook(parentForm, colorText) {
  const formId = extractFormId(parentForm);
  const productId = extractIdNumber(formId);
  const productSelect = getProductSelectElement(productId);

  let sizeText = '';
  const button = parentForm.querySelector('.select-dropdown__button');
  if (button) {
      sizeText = button.textContent.trim();
  } else {
      console.error('Button with the class ".select-dropdown__button" not found inside the form.');
  }

  parentForm.setAttribute('sizeValue', sizeText);
  const disabledVariantId = checkIfOptionDisabled(productSelect, sizeText, colorText);
  const productHandle = parentForm.getAttribute('data-product-handle');

  updateStockStatus(parentForm, disabledVariantId);
  updateOutOfStockLink(parentForm, productHandle, disabledVariantId);
  const labelPreorderDate = getLabelPreorderDate(parentForm);

  if (!disabledVariantId) {
      setTimeout(() => {
          handlePreorderDisplay(labelPreorderDate, parentForm);
      }, 0);
  }
}

// Main function to detect changes within the .product-form-class parent
function handleSizeChangeShopTheLook(target) {
  const parentForm = getClosestParentForm(target);
  if (!parentForm) return;

  const formId = extractFormId(parentForm);
  const productId = extractIdNumber(formId);
  const productSelect = getProductSelectElement(productId);
  let sizeText = getSizeText(target);
  let colorText = getColorTextByVariant(parentForm);

  if (!colorText) {
      const buttons = parentForm.querySelectorAll('.select-dropdown__button');
      if (buttons.length > 1) {
          colorText = buttons[0].textContent.trim();
          sizeText = buttons[1].textContent.trim();
      } else {
          console.error('No buttons with the class ".select-dropdown__button" found inside the form.');
      }
  }

  parentForm.setAttribute('sizeValue', sizeText);
  const disabledVariantId = checkIfOptionDisabled(productSelect, sizeText, colorText);
  const productHandle = parentForm.getAttribute('data-product-handle');

  updateStockStatus(parentForm, disabledVariantId);
  updateOutOfStockLink(parentForm, productHandle, disabledVariantId);
  const labelPreorderDate = getLabelPreorderDate(parentForm);

  setTimeout(() => {
      handlePreorderDisplay(labelPreorderDate, parentForm);
  }, 0);
}

// Helper functions
function getClosestParentForm(target) {
  return target.closest('.product-form-class');
}

function extractFormId(parentForm) {
  return parentForm.getAttribute('id');
}

function extractIdNumber(formId) {
  return formId.match(/\d+/)[0];
}

function getProductSelectElement(productId) {
  return document.querySelector(`#data_product_select_${productId}`);
}

function getSizeText(target) {
  return target.textContent.trim();
}

function getColorTextByVariant(parentForm) {
  return getSelectedLabelTitleByVariantId(parentForm);
}

function checkIfOptionDisabled(productSelect, sizeText, colorText) {
  return isOptionDisabledTest(productSelect, sizeText, colorText);
}

function updateStockStatus(parentForm, disabledVariantId) {
  const outOfStockReminder = parentForm.querySelector('#out-of-stock-reminder-tag');
  const addToCartButton = parentForm.querySelector('#data-add-to-cart-id');

  if (addToCartButton) {
      setTimeout(() => {
          addToCartButton.textContent = disabledVariantId ? 'OUT OF STOCK' : 'ADD TO BAG';
      }, 0);
      addToCartButton.disabled = !!disabledVariantId;
  }
  if (outOfStockReminder) {
      outOfStockReminder.style.display = disabledVariantId ? 'block' : 'none';
  }
}

function updateOutOfStockLink(parentForm, productHandle, disabledVariantId) {
  const outOfStockLink = parentForm.querySelector('#out-of-stock-reminder-tag a#out-of-stock-link');
  if (outOfStockLink) {
      outOfStockLink.href = buildProductUrl(productHandle, disabledVariantId);
  }
}

function buildProductUrl(productHandle, variantId) {
  return `https://www.sferra.com/products/${productHandle}?variant=${variantId}&showPopup=true`;
}

function isOptionDisabledTest(selectElement, targetSize, targetColor) {
  const options = Array.from(selectElement.querySelectorAll('option'));
  const matchingOption = options.find(option => {
      const optionText = option.textContent?.trim();
      const matchesSize = !targetSize.trim() || optionText.includes(targetSize.trim());
      const matchesColor = !targetColor.trim() || optionText.includes(targetColor.trim());
      return matchesSize && matchesColor;
  });
  return matchingOption ? (matchingOption.disabled ? matchingOption.value : null) : null;
}

function getSelectedLabelTitleByVariantId(parentForm) {
  const selectedInput = parentForm.querySelector('#variant-input-id input:checked');
  if (!selectedInput) {
      console.error('No selected input found');
      return '';
  }
  const selectedLabel = selectedInput.closest('label');
  if (!selectedLabel) {
      console.error('Label not found');
      return '';
  }
  return selectedLabel.getAttribute('title');
}

function getLabelPreorderDate(parentForm) {
  const selectedInput = parentForm.querySelector('#variant-input-id input:checked');
  if (!selectedInput) {
      console.error('No selected input found');
      return null;
  }
  const selectedLabel = selectedInput.closest('label');
  if (!selectedLabel) {
      console.error('Label not found');
      return null;
  }
  return selectedLabel.getAttribute('preorder_date');
}

function handlePreorderDisplay(preorderDate, closestForm) {
  if (!closestForm) return;

  const preorderElement = closestForm.querySelector('#data-preorder-date-id');
  const addToCartButton = closestForm.querySelector('#data-add-to-cart-id');

  if (preorderDate) {
      if (addToCartButton) {
          addToCartButton.textContent = 'PRE-ORDER';
      }
      if (preorderElement) {
          preorderElement.style.display = 'block';
      }
  } else {
      if (preorderElement) {
          preorderElement.style.display = 'none';
      }
  }
}
